<div class="modal-body">
    <div class="d-flex justify-content-center mt-3">
        <label class="dialog-centered text-muted">{{idsText | translate}}</label>
    </div>
    <div class="d-flex justify-content-center my-3">
        <button class="admin-new text-uppercase fw-bold px-3" type="button" (click)="activeModal.close('1')">{{idsDeleteButton | translate}}</button>
    </div>
    <div class="d-flex justify-content-center">
        <button class="admin-new text-uppercase fw-bold px-3" type="button" (click)="activeModal.close('0')">{{'IDS_BTN_ABORT' | translate}}</button>
    </div>
</div>